<div class="d-flex flex-column" [style.gap.rem]="2">
  <div class="d-flex flex-column gap-2">
    <div class="fw-semibold">{{ authFlowTitle$ | async }}</div>
    <div class="subtext">{{ authFlowSubtext$ | async }}</div>
  </div>

  <form class="d-flex flex-column w-100" [formGroup]="formGroup" (ngSubmit)="verifyMfaCode()">
    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'timeBasedOneTimePassword'" i18n>Verification Code</label>
      <app-text-input
        #textInput
        formControlName="timeBasedOneTimePassword"
        controlId="timeBasedOneTimePassword"
        [error]="formSubmitted && formGroup.controls.timeBasedOneTimePassword.invalid" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.timeBasedOneTimePassword.invalid"
        [errors]="formGroup.controls.timeBasedOneTimePassword.errors"
        [customErrorMessages]="customErrorMessages.timeBasedOneTimePassword" />
    </div>
  </form>

  <app-button class="w-100" i18n [type]="ButtonTypeEnum.primary" (buttonClick)="verifyMfaCode()">
    Verify Account
  </app-button>
</div>
